import { useSyncExternalStore } from "react";

export type Route =
  | { view: "trade"; coin: string }
  | { view: "portfolio" }
  | { view: "staking" }
  | { view: "stats" };

export const DEFAULT_COIN = "BTC";

export function parse(pathname: string): Route {
  const [first, second] = pathname.split("/").filter(Boolean);
  switch (first) {
    case "portfolio":
      return { view: "portfolio" };
    case "staking":
      return { view: "staking" };
    case "stats":
      return { view: "stats" };
    case "trade":
      return { view: "trade", coin: second && /^[a-z0-9]{1,12}$/i.test(second) ? second.toUpperCase() : DEFAULT_COIN };
    default:
      return { view: "trade", coin: DEFAULT_COIN };
  }
}

export function href(route: Route): string {
  return route.view === "trade" ? `/trade/${route.coin}` : `/${route.view}`;
}

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
window.addEventListener("popstate", notify);

export function navigate(to: string, replace = false): void {
  if (to === window.location.pathname) return;
  if (replace) window.history.replaceState(null, "", to);
  else window.history.pushState(null, "", to);
  window.scrollTo({ top: 0 });
  notify();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePathname(): string {
  return useSyncExternalStore(subscribe, () => window.location.pathname);
}

export function useRoute(): Route {
  return parse(usePathname());
}
